export default __webpack_public_path__ + "static/media/eye.b161d12b.svg";